import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "packageview" }
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "leftcontent" }
const _hoisted_6 = { class: "heroimg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "info" }
const _hoisted_9 = {
  key: 0,
  class: "gg-check blue"
}
const _hoisted_10 = { class: "value" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "rightcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "homebutton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/portal/${_ctx.clientLocationKey}`)))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1),
        _createElementVNode("div", null, "Cancel", -1)
      ])),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item?.Name ?? 'Acvitity does not exist'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.getImage()
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "overview" }, "Overview", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(), (str) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "checkitem flex",
              key: str
            }, [
              (str.startsWith('*'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, _toDisplayString(str.replaceAll('*', '')), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "description",
          innerHTML: _ctx.item?.Description
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "bookbutton",
          onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push(`/portal/${_ctx.clientLocationKey}/${_ctx.type}/${_ctx.typekey}/book`)), ["stop"])),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/portal/${_ctx.clientLocationKey}/${_ctx.type}/${_ctx.typekey}/book`)))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1),
          _createElementVNode("div", null, [
            _createTextVNode("BOOK"),
            _createElementVNode("br"),
            _createTextVNode("NOW")
          ], -1)
        ]), 32)
      ])
    ])
  ]))
}